import { appendPath, getValue } from '@truqc/content-path';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, ModalFooter, Button } from 'reactstrap';
import { enabledSelector, newPathSelector, titleSelector } from '../selectors/index';
import entityComposition from '../../common/classes/entityComposition';
/* eslint-disable-next-line import/no-cycle */
import { getContent } from '../selectors/simpleSelectors';
import { convertToAbsolutePath } from '../utils';
const parseTitleCount = (titleCount, content, path) => {
  const countContentPath = titleCount.countContentPath,
    templates = titleCount.templates;
  const countPath = appendPath(path, countContentPath);
  const value = getValue(countPath, content) || {};
  const nonNullValues = Object.values(value).filter(val => val !== null);
  const count = nonNullValues.length || 0;
  const template = templates[count] || templates[''];
  return template.replace(/#/g, count);
};
class ModalButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }
  invokeActions(actions) {
    const _this$props = this.props,
      parentContentPath = _this$props.parentContentPath,
      reportActions = _this$props.reportActions,
      formActions = _this$props.formActions,
      issueActions = _this$props.issueActions,
      reduxEntity = _this$props.reduxEntity,
      variables = _this$props.variables;
    let handleActions = reportActions.handleActions;
    if (reduxEntity === 'form') {
      handleActions = formActions.handleActions;
    } else if (reduxEntity !== 'issue') {
      handleActions = issueActions.handleActions;
    }
    if (actions.length > 0) {
      handleActions(reduxEntity, actions, parentContentPath, variables);
    }
  }
  handleOpen() {
    const preActions = this.props.preActions;
    this.invokeActions(preActions);
    this.setState({
      isOpen: true
    });
  }
  handleClose() {
    const postActions = this.props.postActions;
    this.invokeActions(postActions);
    this.setState({
      isOpen: false
    });
  }
  render() {
    const _this$props2 = this.props,
      content = _this$props2.content,
      enabled = _this$props2.enabled,
      format = _this$props2.format,
      parentContentPath = _this$props2.parentContentPath,
      title = _this$props2.title,
      children = _this$props2.children;
    const contentPath = format.contentPath,
      titleCount = format.titleCount;
    const absolutePath = convertToAbsolutePath(contentPath, parentContentPath);
    // if format.contentPath, use parentPath to reference the corrected path for countContentPath
    const buttonText = titleCount ? parseTitleCount(titleCount, content, absolutePath) : title;
    const isOpen = this.state.isOpen;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
      isOpen: isOpen,
      style: {
        maxWidth: '800px'
      }
    }, /*#__PURE__*/React.createElement(ModalBody, null, children), /*#__PURE__*/React.createElement(ModalFooter, null, /*#__PURE__*/React.createElement(Button, {
      onClick: this.handleClose,
      className: "t-am-cancel"
    }, "Done"))), /*#__PURE__*/React.createElement(Button, {
      block: true,
      onClick: this.handleOpen,
      disabled: !enabled,
      className: "t-rb-add-button tqc-control modal-button"
    }, buttonText));
  }
}
ModalButton.defaultProps = {
  children: {},
  parentContentPath: '/',
  postActions: [],
  preActions: [],
  title: '',
  transientContext: {},
  variables: {}
};
ModalButton.propTypes = {
  children: PropTypes.node,
  content: PropTypes.shape({
    id: PropTypes.string,
    formType: PropTypes.shape({}),
    issueType: PropTypes.shape({})
  }).isRequired,
  enabled: PropTypes.bool.isRequired,
  formActions: PropTypes.shape({
    handleActions: PropTypes.func
  }).isRequired,
  format: PropTypes.shape({
    contentPath: PropTypes.string,
    titleCount: PropTypes.shape({
      templates: PropTypes.shape({}).isRequired,
      countContentPath: PropTypes.string.isRequired
    })
  }).isRequired,
  issueActions: PropTypes.shape({
    handleActions: PropTypes.func
  }).isRequired,
  parentContentPath: PropTypes.string,
  preActions: PropTypes.arrayOf(PropTypes.shape({})),
  postActions: PropTypes.arrayOf(PropTypes.shape({})),
  reduxEntity: PropTypes.string.isRequired,
  reportActions: PropTypes.shape({
    handleActions: PropTypes.func
  }).isRequired,
  title: PropTypes.string,
  transientContext: PropTypes.shape({}),
  variables: PropTypes.shape({})
};
export { ModalButton as UncomposedModalButton };
export default entityComposition(ModalButton, [], {
  enabled: enabledSelector,
  title: titleSelector,
  path: newPathSelector,
  content: getContent
}, ['report', 'form', 'issue']);